<template>
  <div class="ma-0 pa-0">
    <v-row class="ma-0 pa-0 mt-2 mb-n2" justify="center"
      ><p
        style="
          font-size: 40px;
          font-family: Raleway;
          font-weight: 900 !important;
        "
      >
        {{ pageTitle }}
      </p></v-row
    >
    <div class="md-layout">
      <div
        v-bind:class="gridViewLayout"
        v-for="(item, index) in sharePageFiles"
        :key="index"
      >
        <div class="ma-0 pa-0 mx-10 mb-10">
          <model-viewer
            :style="gridViewViewerStyle"
            id="loading-demo-sub"
            :src="item.fileglb"
            :ios-src="item.fileusdz"
            :poster="item.filepng"
            interaction-prompt="none"
            environment-image="neutral"
            camera-controls
            ar
            ar-modes="webxr scene-viewer quick-look"
            ar-scale="auto"
            alt="A 3D model of an astronaut"
            ><button
              slot="ar-button"
              style="
                background-color: white;
                border-radius: 4px;
                border: none;
                position: absolute;
                top: 16px;
                right: 16px;
              "
            >
              Activate AR
            </button>
          </model-viewer>
          <div class="ma-0 pa-0 mx-5 mt-10" style="font-family: Nunito Sans">
            <div class="ma-0 pa-0" v-if="item.filename">
              <p style="font-weight: 800">File Name</p>
              <div
                class="ma-0 pa-0 mt-n2"
                style="line-height: 1.3; opacity: 0.8"
              >
                <p>{{ item.filename }}</p>
                <p class="mt-n3">Version {{ item.version }}</p>
              </div>
            </div>
            <div class="ma-0 pa-0" v-else style="display: flex">
              <p style="font-weight: 800; opacity: 0.4">File Name</p>
              <v-divider class="ml-3 mt-3" height="30"></v-divider>
            </div>
            <div class="ma-0 pa-0" v-if="item.description">
              <p class="mt-6" style="font-weight: 800">File Description</p>
              <div
                class="ma-0 pa-0 mt-n2"
                style="line-height: 1.3; opacity: 0.8"
              >
                <p>{{ item.description }}</p>
              </div>
            </div>
            <div class="ma-0 pa-0 mt-6" v-else style="display: flex">
              <p style="font-weight: 800; opacity: 0.4">File Description</p>
              <v-divider class="ml-3 mt-3" height="30"></v-divider>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
axios.defaults.xsrfCookieName = "csrftoken";

export default {
  name: "sharePageEdit",
  components: {},
  props: {
    grids: { type: String, default: "1" },
    pageTitle: { type: String, default: "Houseware" },
    sharePageFiles: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data: function () {
    return {
      gridViewLayout: "",
      gridViewViewerStyle: "",
    };
  },
  mounted() {
    if (this.grids === "1") {
      this.gridViewLayout =
        "md-layout-item md-medium-size-100 md-small-size-100 md-size-100";
      this.gridViewViewerStyle = "width: 100%; min-height: 850px; height: 90%;";
    } else if (this.grids === "2") {
      this.gridViewLayout =
        "md-layout-item md-medium-size-100 md-small-size-100 md-size-50";
      this.gridViewViewerStyle = "width: 100%; min-height: 550px; height: 90%;";
    } else if (this.grids === "3") {
      this.gridViewLayout =
        "md-layout-item md-medium-size-100 md-small-size-100 md-size-33";
      this.gridViewViewerStyle = "width: 100%; min-height: 400px; height: 90%;";
    }
  },
  methods: {
    getSharePageFromServer() {
      this.sharepageItems = [];
      axios
        .get(
          this.$abServerPath +
            "/api/sharepages/glbgetsharepage/slug/" +
            this.slug +
            "/",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization:
                "Token " + this.getAuthCookie("augmentableUserToken") + "",
            },
          }
        )
        .then((response) => {
          var item = {
            id: "",
            slug: "",
            pagetitle: "",
            created_at: "",
            updated_at: "",
            tags: "",
            state: "",
            description: "",
            version: "",
            password_required: "",
            grids: 1,
            showFileName: false,
            showFileDescription: false,
            fileIDs: "",
          };

          item = response.data;
          item.id = response.data.id;
          item.slug = response.data.slug;
          item.pagetitle = response.data.pagetitle;
          item.created_at = this.dateFormat(response.data.created_at);
          item.updated_at = response.data.updated_at;
          if (response.data.tags.charAt(0) === "[") {
            //for new tag objects
            item.tags = JSON.parse(response.data.tags);
          } else {
            //for previous tags when they were string not objects
            var obj = {
              title: "",
              color: "",
            };
            obj.title = response.data.tags;
            obj.color = "#ADD8E6";
            item.tags = [];
            item.tags.push(obj);
          }
          item.state = response.data.state;
          item.description = response.data.description;
          item.version = response.data.version;
          item.password_required = response.data.password_required;

          item.showFileName = response.data.showFileName;
          item.showFileDescription = response.data.showFileDescription;
          //string to array
          item.grids = JSON.parse(response.data.grids);
          item.fileIDs = JSON.parse(response.data.fileIDs);
          this.sharepageItems.push(item);
          //console.log(this.sharepageItems[0].fileIDs);
          //this.checkGridViewLayout(item.grids.value);
          this.getSharePageFiles();
        })
        .catch((error) => {
          console.log(error);
          //this.errored = true;
        });
    },
    getSharePageFiles() {
      this.sharePageFiles = [];
      axios
        .get(
          this.$abServerPath +
            "/api/glbfiles/glbgetmultiplefiles/" +
            JSON.stringify(this.sharepageItems[0].fileIDs) +
            "/",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization:
                "Token " + this.getAuthCookie("augmentableUserToken") + "",
            },
          }
        )
        .then((response) => {
          for (var i = 0; i < response.data.length; i++) {
            var r = response.data[i].fields;
            var item = {
              id: "",
              slug: "",
              filename: "",
              filetype: "",
              fileglb: "",

              filepng: "",
              filesize: "",
              created_at: "",
              updated_at: "",
              tags: "",
              state: "",
              description: "",
              version: "",
              fileusdz: "",
              password_required: "",
            };
            item = r;
            item.id = r.id;
            item.slug = r.slug;
            item.filename = r.filename;
            item.filetype = r.filetype.toUpperCase();
            item.fileglb = this.$abServerPath + "/media/" + r.fileglb;
            item.filepng = this.$abServerPath + "/media/" + r.filepng;
            item.fileusdz = this.$abServerPath + "/media/" + r.fileusdz;
            item.filesize = r.filesize;
            item.created_at = this.dateFormat(r.created_at);
            item.updated_at = r.updated_at;
            if (r.tags.charAt(0) === "[") {
              //for new tag objects
              item.tags = JSON.parse(r.tags);
            } else {
              //for previous tags when they were string not objects
              var obj = {
                title: "",
                color: "",
              };
              obj.title = r.tags;
              obj.color = "#ADD8E6";
              item.tags = [];
              item.tags.push(obj);
            }
            item.state = r.state;
            item.description = r.description;
            item.version = r.version;

            item.password_required = r.password_required;

            this.sharePageFiles.push(item);
          }
        })
        .catch((error) => {
          console.log(error);
        });
      //this.sharePageFilesInterval = setInterval(this.getFileFromServer(), 200, this.sharepageItems[0].fileIDs.slice(0));
    },
    checkGridViewLayout(grids) {
      console.log(grids);
      if (grids === "1") {
        this.gridViewLayout =
          "md-layout-item md-medium-size-100 md-small-size-100 md-size-100";
        this.gridViewViewerStyle =
          "width: 100%; min-height: 850px; height: 90%; border-radius: 50px;";
      } else if (grids === "2") {
        this.gridViewLayout =
          "md-layout-item md-medium-size-100 md-small-size-100 md-size-50";
        this.gridViewViewerStyle =
          "width: 100%; min-height: 550px; height: 90%; border-radius: 50px;";
      } else if (grids === "3") {
        this.gridViewLayout =
          "md-layout-item md-medium-size-100 md-small-size-100 md-size-33";
        this.gridViewViewerStyle =
          "width: 100%; min-height: 400px; height: 90%; border-radius: 50px;";
      }
      this.activateLayout = true;
    },
    // getFileFromServer(){

    // },
    getAuthCookie(cname) {
      var name = cname + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },
    dateFormat(x) {
      return (
        "" + x.slice(8, 10) + "." + x.slice(5, 7) + "." + x.slice(0, 4) + ""
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css?family=Raleway:200,300,400,600,700,800,900");
@import url("https://fonts.googleapis.com/css?family=Nunito Sans:200,300,400,600,700,800,900");
</style>